const state = {
  scope: null,
  payout: null,
}

export const getters = {
  payout: state => state.payout,
}

export const mutations = {
  setScope(state, scope) {
    state.scope = scope
  },

  setPayout(state, payout) {
    state.payout = payout
  },

  clearPayout(state) {
    state.payout = null
  },
}

export const actions = accountingService => ({
  async fetchPayout({ commit, state }, id) {
    if (!state.scope) {
      throw new Error('Scope not set')
    }

    // Payout is not available for pica-service scope
    if (state.scope.type === 'pica-service') {
      throw new Error('Payout is not available for pica-service scope')
    }

    commit('clearPayout')
    const payout = await accountingService.fetchPayout(state.scope, id)
    commit('setPayout', payout)
  },

  async downloadPicaServiceExcel({ state }, { payoutId, psId }) {
    if (!state.scope) {
      throw new Error('Scope not set')
    }
    return await accountingService.downloadPayoutPicaService(state.scope, payoutId, psId)
  },
})

export default accountingService => ({
  namespaced: true,
  state,
  getters,
  mutations,
  actions: actions(accountingService)
})
